import script from "./WelcomeBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeBlock.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeBlock.vue?vue&type=style&index=0&id=60ff6794&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ff6794"]])

export default __exports__